import React from 'react';
import { find, get } from 'lodash';
import { push } from 'react-router-redux';

const onEventFaqSubmit = (values = {}, dispatch, props) => {
  const { spaceId, nextPage } = props;

  const listings = get(props, 'listings.data', []);
  const eventListing = find(listings, listing => {
    return 'Event' === listing.use_type;
  }) || {};

  if ('mylistings' === nextPage) {
    return dispatch(push(`/mylistings/${eventListing._id}`));
  }

  return dispatch(push(`/your-space/${spaceId}/event-faqs/${nextPage}`));
};

export default onEventFaqSubmit;
